import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
  },
  //NOTA: Al momento non sarà prevista una login/registrazione interne
  /*   {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'registrazione',
    component: SignUpComponent
  },
  {
    path: 'recupero-password',
    component: RecoverPasswordComponent
  }, */
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GuestRoutingModule { }
